module.exports = __webpack_public_path__ + "img/10-min.5cbb6efa.jpg";